import clsx from 'clsx'

interface DividerProps {
  className?: string
  altColor?: boolean
  vertical?: boolean
}

export const Divider = ({ className, altColor = false, vertical = false }: DividerProps) => {
  const baseColor = altColor ? 'bg-[#e7eaee]' : 'bg-[#D4D4D4]'

  return (
    <div
      role="none"
      className={clsx(
        'rounded-[2px]',
        baseColor,
        vertical
          ? 'w-px' // ✅ vertical
          : 'w-full h-px', // ✅ horizontal (default)
        className,
      )}
    />
  )
}
